import { RefObject } from 'react'

export function scrollToRef(ref: RefObject<HTMLElement>): void {
  window.scrollTo({
    top: ref.current.offsetTop,
    behavior: 'smooth',
  })
}
